import { HttpApiError, HttpApiGroup } from "@effect/platform";
import { Schema } from "effect";
import { endpoint } from "../auth/endpoint";
import {
  DatabaseError,
  DataIntegrityError,
  OpenSearchError,
  SearchQueryTooComplexError,
} from "../auth/errors";

const GetSupportTicketCountsInput = Schema.Struct({
  views: Schema.Array(
    Schema.Struct({
      viewKey: Schema.String,
      filterGroup: Schema.NullOr(Schema.String),
    }),
  ),
});

export const SupportTicketCountsGroup = HttpApiGroup.make("supportTicketCounts")
  .add(
    endpoint.merchant
      .post("getSupportTicketCounts", "/support-ticket-counts")

      .setPayload(GetSupportTicketCountsInput)
      .addSuccess(Schema.Record({ key: Schema.String, value: Schema.Number }))
      .addError(HttpApiError.Forbidden)
      .addError(SearchQueryTooComplexError)
      .addError(OpenSearchError)
      .addError(DatabaseError)
      .addError(DataIntegrityError),
  )
  .prefix("/api");
